module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Amors Pfeile")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("Von Ari McKay")]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("Verliebte Anwälte")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Die erfolgreichen Anwälte Dane Coulter und Cal Monroe sind Rivalen im Gerichtssaal und Freunde hinter den Kulissen. Doch können sie mehr sein?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Cal hat immer heimlich nach Dane geschmachtet. Allerdings verdrängt Dane seine Homosexualität so sehr, dass er nicht mal zugeben kann, dass er möglicherweise schwul ist. Sein Vater, ein fanatischer Homophober, regiert die Familie mit eiserner Hand und drängt Dane zu einer Verlobung – mit einer Frau. Um seine Mutter zu schützen, stimmt Dane zu. Für Cal bringt die Sache jedoch das Fass zum Überlaufen.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Er kann nicht zulassen, dass Dane einen Fehler macht, der sein gesamtes restliches Leben ruiniert und kennt nur einen todsicheren Weg, damit Dane sich eingesteht, wie es in seinem Herzen aussieht. Seinem Freund seine Gefühle zu offenbaren, könnte jedoch nach hinten losgehen und einen Keil zwischen sie treiben. Und selbst dann ist es Dane, der die Entscheidung treffen muss: Das Leben zu leben, das sein Vater von ihm erwartet oder alles, was er hat, für die Chance auf Glück in Cals Armen aufzugeben.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-677943bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0002.vue
// module id = 60
// module chunks = 0